import { ElfsightWidget } from "./ElfsightWidget";

export const Avis = () => {
    return (
        <section>
            <h2 className="font-bold text-4xl text-left mx-3 py-8">Nos avis clients</h2>
            <ElfsightWidget />
        </section>
    )
}